// externals
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';
import { offerSessionUtils } from '@makemydeal/dr-shared-ui-utils';

// libraries
import type { DashMiddleware, DashNext, DashStore } from '@makemydeal/dr-shared-store';

// actions
import { commonConsumerIdReceived } from '../actions/commonConsumerIdActionCreators';

// action types
import { SOCKET_EVENT_IGNORED, SOCKET_EVENT_RECEIVED, UPDATE_OMS_ORDER_NUMBER } from '../actionTypes/socketActionTypes';

// selectors
import * as offerReduxSelectors from '../selectors/offerRedux';

const DEAL_XG_TOPICS: ReadonlySet<string> = new Set(['dealXgPatch', 'dealXgCreate']);

export const commonConsumerIdMiddleware: DashMiddleware = (store: DashStore) => (next: DashNext) => (action: AnyFSA) => {
    const result = next(action);

    switch (action.type) {
        case SOCKET_EVENT_RECEIVED:
        case SOCKET_EVENT_IGNORED:
        case UPDATE_OMS_ORDER_NUMBER: {
            // Every read is post-next(): no reducer on these three types touches commonConsumerId, so
            // pre- and post-next state are identical for it, and the post-next value is the honest
            // "what does the store hold now" for the empty-id guard.
            const state = store.getState();
            const event = action.meta?.sourceEvent ?? action.payload ?? {};

            const isDealXgEvent = DEAL_XG_TOPICS.has(event.topic) && !event.message?.includes('subscribe');
            const isCurrentDeal = !!event.data?.dealId && event.data.dealId === offerReduxSelectors.getDealXgId(state);
            const commonConsumerId = event.data?.dealStructure?.participants?.buyer?.commonConsumerId;

            if (isDealXgEvent && isCurrentDeal && commonConsumerId && !offerReduxSelectors.getShopperCommonConsumerId(state)) {
                logNewRelicPageAction('MV:WebSocket', {
                    type: 'commonConsumerIdReceived',
                    dealId: event.data.dealId,
                    eventTopic: event.topic
                });

                offerSessionUtils.setCommonConsumerId(commonConsumerId);

                store.dispatch(
                    commonConsumerIdReceived({
                        commonConsumerId,
                        commonOrgId: offerReduxSelectors.getCommonOrgId(state) || event.data.coxAutoReferences?.commonOrgId
                    })
                );
            }
            break;
        }
    }

    return result;
};
